import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
const industryMeta: Record<string, {
  name: string;
  tagline: string;
}> = {
  conveyancing: {
    name: 'Conveyancing',
    tagline: 'AI-powered workflows for modern legal property transfers.'
  },
  renewables: {
    name: 'Renewables',
    tagline: 'Intelligent automation for energy asset management.'
  },
  maritime: {
    name: 'Maritime',
    tagline: 'Autonomous fleet coordination and compliance.'
  },
  'field-services': {
    name: 'Field Services',
    tagline: 'Smarter dispatch, digital work orders, zero downtime.'
  }
};
export function IndustryPlaceholder() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const meta = industryMeta[slug || ''] || {
    name: 'Industry',
    tagline: 'Purpose-built AI agents for your sector.'
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="relative z-10 min-h-screen flex items-center justify-center py-40" data-id="element-881">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-882">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} data-id="element-883">
          <p className="text-sm font-bold tracking-widest text-brand-orange uppercase mb-6" data-id="element-884">
            Aijentik for {meta.name}
          </p>
          <h1 className="text-5xl md:text-6xl font-display mb-6 tracking-tight" data-id="element-885">
            Coming Soon.
          </h1>
          <p className="text-xl text-gray-400 font-light mb-12 max-w-xl mx-auto" data-id="element-886">
            {meta.tagline} <br data-id="element-887" />
            This dedicated page is under development.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-888">
            <a href="mailto:sales@aijentik.com" className="bg-brand-orange hover:bg-brand-deep-orange text-white px-8 py-4 rounded-full font-medium transition-all duration-300 shadow-[0_0_40px_rgba(219,127,74,0.3)] hover:shadow-[0_0_60px_rgba(219,127,74,0.4)]" data-id="element-889">
              Contact Us — sales@aijentik.com
            </a>
            <Link to="/" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 font-medium" data-id="element-890">
              <ArrowLeft className="w-4 h-4" data-id="element-891" />
              Back to Home
            </Link>
          </div>
        </motion.div>
      </div>
    </main>;
}